/**
 * @generated SignedSource<<381730c31ec05ff7b5831aa1d41f9841>>
 * @relayHash eec5dd1a1cce9fafcb935ada9e1e40da
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/413.0.0-2023-05-09T14:43:46.011Z/PdpSharedShippingInfoSidebarQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PdpSharedShippingInfoSidebarQuery$variables = {
  calculateLowerShippingInfo?: boolean | null;
  fetchItem?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchUser?: boolean | null;
  isClient?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemQuantity?: number | null;
  shippingRegions?: ReadonlyArray<string | null> | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type PdpSharedShippingInfoSidebarQuery$data = {
  readonly viewer: {
    readonly itemRead?: ReadonlyArray<{
      readonly serviceId?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLowerShippingInfo_item" | "PdpSharedShippingInfoLink_item" | "PdpSharedShippingInfoWrapper_item" | "useShippingPrice_item" | "useShippingType_item">;
    } | null> | null;
    readonly regionSelectorEnabled: boolean | null;
    readonly relevantShipping: {
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
      } | null;
    } | null;
    readonly user?: {
      readonly addressBook: {
        readonly addressList: ReadonlyArray<{
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null> | null;
        readonly personalAddress: {
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
        readonly proAddress: {
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
      } | null;
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPromoCode_user" | "PdpSharedShippingAddress_user" | "PdpSharedShippingInfoLink_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLowerShippingInfo_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingAddress_viewer" | "PdpSharedShippingHolidayDelivery_viewer" | "PdpSharedShippingInfoLink_viewer" | "useShippingPrice_viewer" | "useShippingType_viewer">;
  };
};
export type PdpSharedShippingInfoSidebarQuery = {
  response: PdpSharedShippingInfoSidebarQuery$data;
  variables: PdpSharedShippingInfoSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "calculateLowerShippingInfo"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchItem"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isClient"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v8 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "shippingRegions"
},
v9 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v12 = {
  "alias": "regionSelectorEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "pdpRegionSelector"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"pdpRegionSelector\")"
},
v13 = {
  "kind": "Variable",
  "name": "fetchRegionalInfo",
  "variableName": "fetchRegionalInfo"
},
v14 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v15 = {
  "kind": "Variable",
  "name": "userZipCode",
  "variableName": "userZipCode"
},
v16 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v18 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v19 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v20 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v21 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v22 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      (v24/*: any*/)
    ],
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v30 = {
  "kind": "Variable",
  "name": "itemQuantity",
  "variableName": "itemQuantity"
},
v31 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v32 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "itemIds.0",
        "variableName": "itemId"
      }
    ],
    "kind": "ListValue",
    "name": "itemIds"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v34 = {
  "kind": "Literal",
  "name": "fetchShippingCostInfo",
  "value": true
},
v35 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v36 = {
  "kind": "Variable",
  "name": "shippingRegions",
  "variableName": "shippingRegions"
},
v37 = [
  (v31/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v40 = [
  (v38/*: any*/),
  (v39/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v43 = [
  (v41/*: any*/),
  (v42/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v45 = [
  (v33/*: any*/),
  (v42/*: any*/)
],
v46 = [
  (v38/*: any*/),
  (v39/*: any*/),
  (v42/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  }
],
v47 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v48 = {
  "condition": "fetchRegionalInfo",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "regionsInfo",
      "args": [
        (v18/*: any*/),
        (v21/*: any*/)
      ],
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RegionsByZipCode",
          "kind": "LinkedField",
          "name": "regionsByZipCode",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v42/*: any*/)
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedShippingInfoSidebarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingHolidayDelivery_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedPromoCode_viewer"
          },
          {
            "condition": "calculateLowerShippingInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v16/*: any*/),
                "kind": "FragmentSpread",
                "name": "PdpSharedLowerShippingInfo_viewer"
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingAddress_viewer"
          },
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "useShippingPrice_viewer"
          },
          {
            "args": [
              (v13/*: any*/),
              (v19/*: any*/),
              (v30/*: any*/),
              (v14/*: any*/),
              (v31/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "useShippingType_viewer"
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v32/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v33/*: any*/),
                      {
                        "args": [
                          (v17/*: any*/),
                          (v34/*: any*/),
                          (v30/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingPrice_item"
                      },
                      {
                        "condition": "calculateLowerShippingInfo",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              (v17/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v30/*: any*/),
                              (v36/*: any*/),
                              (v14/*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "PdpSharedLowerShippingInfo_item"
                          }
                        ]
                      },
                      {
                        "args": [
                          (v30/*: any*/),
                          (v31/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingType_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoLink_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoWrapper_item"
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v40/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v40/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v40/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedPromoCode_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingAddress_user"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v11/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PdpSharedShippingInfoSidebarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": [
              (v19/*: any*/),
              (v31/*: any*/)
            ],
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v43/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "kind": "LinkedField",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "abbreviation",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v22/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v28/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "showShippingDiscounts",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "subsidizedShippingPDP"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
          },
          (v42/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v19/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCheckoutBlocked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "RelevantShippingInfo",
                "kind": "LinkedField",
                "name": "relevantShipping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "kind": "LinkedField",
                    "name": "shipmentQuotes",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      (v44/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalAmount",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "kind": "LinkedField",
                        "name": "serviceMethod",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceMethodType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Region",
                            "kind": "LinkedField",
                            "name": "region",
                            "plural": false,
                            "selections": (v43/*: any*/),
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v17/*: any*/),
                  (v19/*: any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v37/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v46/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v46/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v46/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v37/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v47/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v37/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "alias": "canRequestShippingQuotePermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_REQUEST_SHIPPING_QUOTE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "calculateLowerShippingInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v48/*: any*/)
            ]
          },
          (v48/*: any*/),
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v32/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vertical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "kind": "LinkedField",
                        "name": "shipmentQuotes",
                        "plural": true,
                        "selections": [
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "USD",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentServiceMethod",
                            "kind": "LinkedField",
                            "name": "serviceMethod",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Region",
                                "kind": "LinkedField",
                                "name": "region",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "regionName",
                                    "storageKey": null
                                  },
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v17/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "useLiveEndpoint",
                            "value": true
                          }
                        ],
                        "concreteType": "RelevantShippingInfo",
                        "kind": "LinkedField",
                        "name": "relevantShippingInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuote",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "buyerTotalAmount",
                                "plural": false,
                                "selections": (v25/*: any*/),
                                "storageKey": null
                              },
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": (v45/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "priceType",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "buyerId",
                            "value": ""
                          },
                          {
                            "kind": "Literal",
                            "name": "isTrade",
                            "value": false
                          }
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "displayPrice(buyerId:\"\",isTrade:false)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": "itemIsOnHold",
                        "args": [
                          (v17/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPrivateListing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "kind": "LinkedField",
                            "name": "leadTime",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "calculateLowerShippingInfo",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 0
                              },
                              (v36/*: any*/)
                            ],
                            "concreteType": "moreLikeThisConnection",
                            "kind": "LinkedField",
                            "name": "moreLikeThis",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalResults",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v17/*: any*/),
                              (v35/*: any*/),
                              (v14/*: any*/)
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v42/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/413.0.0-2023-05-09T14:43:46.011Z/PdpSharedShippingInfoSidebarQuery",
    "metadata": {},
    "name": "PdpSharedShippingInfoSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c12df30247ca0dacbc6bad5ac4044872";

export default node;
